export const PROCESSING_WORKING_SHIFT = "PROCESSING_WORKING_SHIFT";
export const GET_WORKING_SHIFT = "GET_WORKING_SHIFT";
export const ADD_WORKING_SHIFT = "ADD_WORKING_SHIFT";
export const UPDATE_WORKING_SHIFT = "UPDATE_WORKING_SHIFT";
export const DELETE_WORKING_SHIFT = "DELETE_WORKING_SHIFT";
